import "./activity-table.css";
import { useState, createRef, useContext } from "react";
import { tableObject, nameMapping } from "../data/tableData";
import { AuthContext } from "../Auth.js";
import { effectiveTier, canAccessActivity } from "../data/tierAccess";

export function ActivityTable(props) {
  const [query, setQuery] = useState("");
  const { authUserData } = useContext(AuthContext);
  const tier = effectiveTier(authUserData);
  // Locks/tier-gating only apply on the interactive play table (LeftDrawer).
  // The home/landing preview renders <ActivityTable /> with no props for a
  // logged-out audience (tier === null), where every row would otherwise show
  // as locked — so gating is opt-in via this prop.
  const gated = !!props.gated;
  function buildRefObject(){
    let refObj = {}
    Object.keys(tableObject).forEach((category,categoryIndex)=>{
      refObj[categoryIndex]={}
      Object.keys(tableObject[category]).forEach((level,lvlIndex)=>{
        refObj[categoryIndex][lvlIndex]={}
        tableObject[category][level].forEach((activity,activityIndex)=>{
          refObj[categoryIndex][lvlIndex][activityIndex]=createRef()
        })
      })
    })
    return refObj
  }
  const refObj = buildRefObject();
  //console.log(refObj)
  function tableClickHandler(props,category,activityName){
      // The home/landing preview renders this table with no navigation props,
      // so clicking a row there is a no-op rather than a crash.
      if (typeof props.changePdf !== "function") {
        return;
      }
      let shortActivityName = activityName in nameMapping? nameMapping[activityName] : activityName.replaceAll(" ", "")
      //console.log("Table Click", category, activityName, shortActivityName)
      let cat = category.replaceAll(" ","")
      props.changePdf(
        "/"+cat+"/" + shortActivityName + ".pdf",
      );
      props.changePdf2(
        "/"+cat+"/" + shortActivityName + "HELP.pdf",
      );
      props.closeDrawer(false);
    }

  function setMatches() {
    //console.log("looking for", query)
    Object.keys(tableObject).forEach((category,categoryIndex)=>{
      Object.keys(tableObject[category]).forEach((level,lvlIndex)=>{
        tableObject[category][level].forEach((activity,activityIndex)=>{
          // Locked rows keep their disabled styling — don't highlight them.
          if (gated && !canAccessActivity(tier, activity)) {
            return;
          }
          if (activity.toLowerCase().includes(query.toLowerCase())) {
            refObj[categoryIndex][lvlIndex][activityIndex].current.style.backgroundColor = "lightgreen";
          }
          else{
            refObj[categoryIndex][lvlIndex][activityIndex].current.style.backgroundColor = "inherit";
          }
        })
      })
    })
  }

  return (
    <div id="activityTableWrapper">
      <div id="TSearchSection">
        <div
          className="activitySectionHeader"
          style={{ height: "100%", display: "flex", alignItems: "flex-start" }}
        >
          Activities
        </div>
        <div style={{ display: "flex" }}>
          <input
            id="tableSearch"
            type="text"
            placeholder="Search Activites"
            onChange={(e) => {
              setQuery(e.target.value);
            }}
          />
          <button
            className="yellowButton"
            style={{ width: "90px" }}
            onClick={() => 
              setMatches()}
          >
            Enter
          </button>
        </div>
      </div>
      <div style={{ display: "flex" }}>
          {Object.keys(tableObject).map((category,categoryIndex) =>
          <table className="outerTable">
          <thead>
            <div style={{ padding: "0.5rem" }}>{category}</div>
          </thead>
          {Object.keys(tableObject[category]).map((level,lvlIndex) =>
          <tbody>
          <tr className={lvlIndex % 2 === 1 ? "yellBG" : ""}>
            <th>{level}
            
            </th>
          </tr>
          {tableObject[category][level].map((activity,activityIndex) => {
          const locked = gated && !canAccessActivity(tier, activity);
          return (
          <tr
            key={activity}
            ref={refObj[categoryIndex][lvlIndex][activityIndex]}
            onClick={() => {
              if (locked) {
                // Don't silently no-op — tell the user what plan they need.
                props.onLockedActivity?.(activity);
                return;
              }
              tableClickHandler(props,category,activity)
            }}
            className={`${lvlIndex % 2 === 1 ? "yellBG" : ""}${locked ? " lockedRow" : ""}`}
            title={locked ? "Not in your plan" : undefined}
            aria-disabled={locked}
          >
            <td>{activity}</td>
          </tr>
          );
          })}
          </tbody>
          )}
          </table>)}
        
      </div>
    </div>
  );
}
